import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { isAdminRole } from "../../utils/peoplePermissions";
import { SETTINGS_HOME_PATH } from "../../config/featureFlags";
import { hasMasterSession } from "../../utils/authSession";

function getActiveSession(state) {
  if (hasMasterSession(state.loginToken)) {
    return state.loginToken.response;
  }
  if (state.loginTokenCoUser?.response?.token) {
    return state.loginTokenCoUser.response;
  }
  return null;
}

function RequireAdmin({
  children,
  redirectTo = SETTINGS_HOME_PATH,
}) {
  const session = useSelector(getActiveSession);
  const roleName = session?.user?.role_name;

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdminRole(roleName)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}

export default RequireAdmin;
